import { LogErrors } from './../../LogErrors'
import { DoubleAttempt } from './../Helpers/DoubleAttempt'

/**
 * Obtiene el total de licencias contratadas por el centro.
 */
const GetContractedLicenses = async (idCenter, idUserRol, token) => {
    try {
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify({ idCenter, idUserRol })
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V5/Reports/GetContractedLicenses`
        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetContractedLicenses - DL Licenses', error)
        return { success: false, message: `No ha sido posible obtener las licencias contratadas.` }
    }
}

/**
 * Obtiene el total de licencias asignadas a instructores en el centro.
 */
const GetTotalAssignedLicenses = async (idCenter, idUserRol, token) => {
    try {
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify({ idCenter, idUserRol })
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V5/Reports/GetTotalAssignedLicenses`
        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetTotalAssignedLicenses - DL Licenses', error)
        return { success: false, message: `No ha sido posible obtener las licencias asignadas.` }
    }
}

/**
 * Obtiene el total de licencias utilizadas/consumidas por estudiantes en el centro.
 */
const GetTotalUsedLicenses = async (idCenter, idUserRol, token) => {
    try {
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify({ idCenter, idUserRol })
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V5/Reports/GetTotalUsedLicenses`
        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetTotalUsedLicenses - DL Licenses', error)
        return { success: false, message: `No ha sido posible obtener las licencias utilizadas.` }
    }
}

/**
 * Obtiene el total de licencias restantes/disponibles para asignar.
 */
const GetTotalRemainingLicenses = async (idCenter, idUserRol, token) => {
    try {
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify({ idCenter, idUserRol })
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V5/Reports/GetTotalRemainingLicenses`
        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetTotalRemainingLicenses - DL Licenses', error)
        return { success: false, message: `No ha sido posible obtener las licencias restantes.` }
    }
}

const GetInstructorsForAssignLicenses = async (idCenter, token) => {
    try {
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify({ idCenter })
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V5/Leaders/GetInstructorsForAssignLicenses`
        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetInstructorsForAssignLicenses - DL Licenses', error)
        return { success: false, message: `No ha sido posible obtener la lista de instructores.` }
    }
}

const GetCoursesForAssignLicenses = async (idCenter, token) => {
    try {
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify({ idCenter })
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V5/Leaders/GetCoursesForAssignLicenses`
        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetCoursesForAssignLicenses - DL Licenses', error)
        return { success: false, message: `No ha sido posible obtener la lista de cursos.` }
    }
}

const AssignInstructorLicenses = async (idCenter, idCenterUser, idCourse, quantity, token) => {
    try {
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify({ idCenter, idCenterUser, idCourse, quantity })
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V5/Leaders/AssignInstructorLicenses`
        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('AssignInstructorLicenses - DL Licenses', error)
        return { success: false, message: `No ha sido posible asignar las licencias al instructor.` }
    }
}

/**
 * Consulta cuántas licencias ya tiene asignadas un instructor para un curso específico,
 * para prellenar el campo "Número de licencias" al elegir el curso en /leader/licenses/assign.
 */
const GetInstructorAssignedLicensesForCourse = async (idCenter, idCenterUser, idCourse, token) => {
    try {
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify({ IdCenter: idCenter, IdUserRol: 3, IdCenterUser: idCenterUser, IdCourse: idCourse })
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V5/Reports/GetInstructorAssignedLicensesForCourse`
        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetInstructorAssignedLicensesForCourse - DL Licenses', error)
        return { success: false, message: `No ha sido posible obtener las licencias asignadas para este curso.` }
    }
}

const GetInstructorForUpdateLicenses = async (idCenter, token, idCenterUser = null, idCourse = null) => {
    try {
        const body = { idCenter }
        if (idCenterUser !== null) body.idCenterUser = idCenterUser
        if (idCourse !== null) body.idCourse = idCourse

        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(body)
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V5/Leaders/GetInstructorForUpdateLicenses`
        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetInstructorForUpdateLicenses - DL Licenses', error)
        return { success: false, message: `No ha sido posible obtener la lista de licencias de instructores.` }
    }
}

const GetAssignedLicensesForInstructor = async (idCenter, token) => {
    try {
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify({ idCenter, idUserRol: 3 })
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V5/Reports/GetAssignedLicensesForInstructor`
        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetAssignedLicensesForInstructor - DL Licenses', error)
        return { success: false, message: `No ha sido posible obtener la lista de licencias asignadas.` }
    }
}

/**
 * Obtiene las listas de instructores y cursos que ya tienen al menos una licencia utilizada,
 * para poblar los desplegables de filtro del reporte de licencias utilizadas.
 * Los id devueltos son los que GetUsedLicensesReport espera en idInstructor/idCourse.
 */
const GetInfoForFiltersToLicensesUsed = async (idCenter, token) => {
    try {
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify({ idCenter, idUserRol: 3 })
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V5/Reports/GetInfoForFiltersToLicensesUsed`
        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetInfoForFiltersToLicensesUsed - DL Licenses', error)
        return { success: false, message: `No ha sido posible obtener la información de los filtros.` }
    }
}

/**
 * Obtiene el reporte de licencias utilizadas (instructor -> curso -> estudiante que la consumió).
 * Los filtros idInstructor (CenterUsers.Id) e idCourse son opcionales; al omitirlos se
 * devuelve el reporte completo.
 */
const GetUsedLicensesReport = async (idCenter, token, idInstructor = null, idCourse = null) => {
    try {
        const body = { idCenter, idUserRol: 3 }
        if (idInstructor !== null) body.idInstructor = idInstructor
        if (idCourse !== null) body.idCourse = idCourse

        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(body)
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V5/Reports/GetUsedLicensesReport`
        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetUsedLicensesReport - DL Licenses', error)
        return { success: false, message: `No ha sido posible obtener el reporte de licencias utilizadas.` }
    }
}

/**
 * Libera (desvincula) el registro de licencias de uno o más pares instructor/curso,
 * devolviendo esas cantidades al cupo disponible del centro. Es el inverso de
 * AssignInstructorLicenses.
 *
 * Semántica "todo o nada": si cualquier ítem del lote falla, se rechaza el lote completo.
 *
 * @param {number} idCenter - Identificador del centro.
 * @param {Array<{idCenterUser: number, idCourse: number}>} licenses - Pares a liberar.
 * @param {string} token - Token de sesión.
 */
const RemoveInstructorLicenses = async (idCenter, licenses, token) => {
    try {
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify({ idCenter, licenses })
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V5/Leaders/RemoveInstructorLicenses`
        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('RemoveInstructorLicenses - DL Licenses', error)
        return { success: false, message: `No fue posible desvincular las licencias.` }
    }
}

const UpdateAssignLicenses = async (idCenter, licenses, token) => {
    try {
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify({ idCenter, licenses })
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V5/Leaders/UpdateAssignLicenses`
        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('UpdateAssignLicenses - DL Licenses', error)
        return { success: false, message: `No fue posible actualizar el número de licencias.` }
    }
}

/**
 * Consulta si el centro está en modalidad de licencias gratuitas ("isFreeLicenses").
 * Se usa en el dashboard del Líder para decidir si el tile "Licencias Ztudia" debe
 * habilitarse (isFreeLicenses === false) o permanecer deshabilitado (true).
 */
const GetCenterFreeLicensesStatus = async (idCenter, idUserRol, token) => {
    try {
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify({ IdCenter: idCenter, IdUserRol: idUserRol })
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V5/Users/GetCenterFreeLicensesStatus`
        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetCenterFreeLicensesStatus - DL Licenses', error)
        return { success: false, message: `No ha sido posible consultar el estado de licencias gratuitas del centro.` }
    }
}

export {
    GetContractedLicenses,
    GetTotalAssignedLicenses,
    GetTotalUsedLicenses,
    GetTotalRemainingLicenses,
    GetInstructorsForAssignLicenses,
    GetCoursesForAssignLicenses,
    AssignInstructorLicenses,
    GetInstructorAssignedLicensesForCourse,
    GetInstructorForUpdateLicenses,
    GetAssignedLicensesForInstructor,
    GetInfoForFiltersToLicensesUsed,
    GetUsedLicensesReport,
    RemoveInstructorLicenses,
    UpdateAssignLicenses,
    GetCenterFreeLicensesStatus
}
